import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';

import { comCorpo } from '@/lib/pedido';

/**
 * A utilidade de uma resposta da IA (etapa C; guia 6.3, migracao 0076): a
 * pessoa que pediu diz se serviu, e pode dizer por que nao serviu. A mesma
 * logica para a mesa e para o celular — so o desenho muda.
 *
 * O estado mostrado e o que o SERVIDOR devolveu, e nao o toque: se a nota nao
 * gravou, a tela nao finge que gravou.
 */
export interface NotaDaResposta {
  readonly util: boolean;
  readonly motivo: string | null;
}

export function useUtilidade(perguntaId: string, inicial: boolean | null | undefined) {
  const [nota, setNota] = useState<NotaDaResposta | null>(inicial === null || inicial === undefined ? null : { util: inicial, motivo: null });
  /* "Nao serviu" abre o campo do motivo; o motivo e opcional. */
  const [pedindoMotivo, setPedindoMotivo] = useState(false);
  const avaliar = useMutation({
    mutationFn: (corpo: { util: boolean; motivo?: string }) =>
      comCorpo<NotaDaResposta>('POST', `/ia/respostas/${encodeURIComponent(perguntaId)}/utilidade`, corpo),
    /* A nota aparece no proprio controle; um aviso a cada toque seria ruido. */
    meta: { silencioso: true },
    onSuccess: (r) => {
      setNota(r);
    },
  });
  return {
    nota,
    pedindoMotivo,
    ocupado: avaliar.isPending,
    serviu: () => {
      setPedindoMotivo(false);
      avaliar.mutate({ util: true });
    },
    naoServiu: () => {
      setPedindoMotivo(true);
      avaliar.mutate({ util: false });
    },
    enviarMotivo: (motivo: string) => {
      const m = motivo.trim();
      setPedindoMotivo(false);
      if (m.length >= 3) avaliar.mutate({ util: false, motivo: m });
    },
    fecharMotivo: () => {
      setPedindoMotivo(false);
    },
  };
}
